/* Boreal Gaming — page body (sections/page-template.liquid).
   - Pages that lay out their own columns (.row with 2+ cols) switch to the wide
     layout; the shorter column is treated as the side card.
   - Otherwise, 3+ h2 (or h3) headings build the "On this page" list in the side rail,
     with the current section highlighted while scrolling. */
(function () {
  var page = document.querySelector('[data-bm-page]');
  if (!page || page.dataset.bmReady) return;
  page.dataset.bmReady = '1';

  var content = page.querySelector('[data-bm-page-content]');
  var rail = page.querySelector('[data-bm-page-rail]');
  var toc = page.querySelector('[data-bm-toc]');
  var list = page.querySelector('[data-bm-toc-list]');
  if (!content) return;

  // Content laid out in two or more columns (e.g. a side "Contact us" card
  // next to the text): keep the columns, make the narrow one the side card.
  var multi = false;
  Array.prototype.forEach.call(content.querySelectorAll('.row'), function (row) {
    var cols = Array.prototype.filter.call(row.children, function (c) { return /(^|\s)col-/.test(c.className); });
    if (cols.length < 2) return;
    multi = true;
    var narrow = cols.reduce(function (a, b) { return b.textContent.length < a.textContent.length ? b : a; });
    cols.forEach(function (c) { c.classList.add(c === narrow ? 'bm-page__aside-col' : 'bm-page__main-col'); });
  });
  // Pages that are mainly an embedded app or widget (e.g. the release calendar):
  // no text blocks of their own, so give the widget the full width.
  var embed = !multi && content.querySelector('script[src], iframe, [class*="-root"], [id*="calendar"]') &&
    !content.querySelector(':scope > :is(p, h2, h3, ul, ol, table)');
  if (multi || embed) {
    page.classList.add('bm-page--wide');
    if (embed) page.classList.add('bm-page--embed');
    return;
  }
  page.classList.remove('bm-page--wide');

  function pick(sel) {
    return Array.prototype.slice.call(content.querySelectorAll(sel)).filter(function (h) {
      return h.textContent.trim().length > 0;
    });
  }
  var heads = pick('h2');
  if (heads.length < 3) heads = pick('h3');
  if (heads.length < 3 || !toc || !list) {
    if (rail && rail.hidden) page.classList.add('bm-page--single');
    return;
  }

  var used = {};
  var links = [];
  heads.forEach(function (h) {
    var label = h.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '');
    if (label.length > 3 && label === label.toUpperCase() && /[A-Z]/.test(label)) {
      label = label.charAt(0) + label.slice(1).toLowerCase();
    }
    if (!h.id) {
      var base = label.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      var id = base, n = 2;
      while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
      h.id = id;
    }
    used[h.id] = true;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = label;
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });

  toc.hidden = false;
  if (rail) rail.hidden = false;
  page.classList.add('bm-page--toc');

  if (!('IntersectionObserver' in window)) return;
  var current = null;
  function mark(id) {
    if (id === current) return;
    current = id;
    links.forEach(function (a) {
      if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); });
  }, { rootMargin: '-90px 0px -65% 0px' });
  heads.forEach(function (h) { io.observe(h); });
})();
